"use client";

import { useEffect, useState } from "react";
import { subscribeToAppEvents } from "../../events";
import { ConsentAcceptedEvent } from "../../events/consent-accepted.event";
import { ConsentNotShowedEvent } from "../../events/consent-not-showed.event";
import { ConsentRejectedEvent } from "../../events/consent-rejected.event";

export function useConsentApplied() {
  const [consentApplied, setConsentApplied] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeToAppEvents((event) => {
      if (
        event instanceof ConsentAcceptedEvent ||
        event instanceof ConsentRejectedEvent ||
        event instanceof ConsentNotShowedEvent
      ) {
        setConsentApplied(true);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return consentApplied;
}
